// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"3abf51e6","821":"1ab1e4ee"}[chunkId] + ".chunk.js";
};